<template>
  <div class="panel">
    <Header :userinfo="userInfo"></Header>
    <div class="content">
      <div class="banner">
        <img src="../assets/panel_banner.png" alt>
      </div>
      <div v-if="resourceModule.length>0" class="bd">
        <div class="section">
          <div class="section-hd">
            互动授课
            <span class="tip">已有<span>80%</span>教师正在使用</span>
          </div>
          <div class="section-bd">
            <!-- <div v-if="isShow === true && (vipStatus === 1|| vipStatus === 3) && !resourcePath" class="section-item" @click="ebookActivation(vipStatus)">
              <div class="item-img">
                <img src="../assets/pic_read.png" alt>
              </div>
              <div class="item-title">同步配套电子教材</div>
            </div> -->
            <!-- <div class="section-item" v-else-if="isShow === true && resourcePath" @click="toResourcePage(resourcePath)">
              <div class="item-img">
                <img src="../assets/pic_read.png" alt>
              </div>
              <div class="item-title">同步配套电子教材</div>
            </div> -->
            <div class="section-item" @click="ebookActivation">
              <div class="item-img">
                <img src="../assets/pic_read.png" alt>
              </div>
              <div class="item-title">同步配套电子教材</div>
            </div>
            <div class="section-item" @click="showCode()">
              <div class="item-img">
                <img src="../assets/pic_select.png" alt>
              </div>
              <div class="item-title">课前预习/课后复习</div>
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-hd">
            教学资源库
            <span class="tip">已收录<span>180万</span>个资源文件</span>
            <a class="outlink" href="https://res.kingsun.cn" target="_blank">绘本、歌曲、电影&gt;&gt;</a>
          </div>
          <div class="section-bd">
            <div class="section-item" v-for="(resource, index) in resourceModule" :key="resource.name" @click="toResoureList(index, resource.resourceTypeId, resource.categoryId, resource.resourceExtTypeId)">
              <div class="item-img">
                <img v-if="resource.isNew" src="../assets/ric_new.png" alt class="new">
                <img class="icon" v-bind:src="resource.imgUrl" alt>
              </div>
              <div class="item-title">{{resource.resourceTypeName}}</div>
            </div>
          </div>
        </div>
        <div class="right-side">
          <TeacherInfo ref="teacherInfo" :userinfo="userInfo"></TeacherInfo>
        </div>
      </div>
      <div class="slogan">
        <span><em>·</em>深圳市“新课程 新课堂”单元教学资源包、录像课例获奖作品指定展示平台</span>
        <span><em>·</em>深圳市“演中学”课本剧剧本和录像获奖作品指定展示平台</span>
      </div>
    </div>
    <Footer></Footer>
    <!-- <BindMobilePhoneDialog ref="mobileBind" @onBinded="afterBindMobile" @onCreateAccount="onCreateAccount"></BindMobilePhoneDialog> -->
    <BindSubjectDialog ref="BindSubjectDialog" @onSetSubjext="afterBindSubject"></BindSubjectDialog>
    <QRcode ref="myCode"></QRcode>
    <EbookActivationDialog ref="activationDialog" @afterActive="afterActive"></EbookActivationDialog>
    <!-- 跳转金太阳老师提示 -->
    <ToKingsunTeacherDialog ref="toKingsunTeacherDialog"></ToKingsunTeacherDialog>
    <!-- 完善个人信息dialog -->
    <CompleteInfoDialog ref="CompleteInfoDialog"></CompleteInfoDialog>
    <!-- 同步学二维码dialog -->
    <TBXCodeDialog ref="TBXCodeDialog"></TBXCodeDialog>
  </div>
</template>
<script>
import api from '@/utils/api'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer'
import TeacherInfo from '@/components/TeacherInfo'
// import BindMobilePhoneDialog from '@/components/BindMobilePhoneDialog.vue'
import BindSubjectDialog from '@/components/BindSubjectDialog.vue'
import QRcode from '@/components/QRcodeDialog'
import EbookActivationDialog from '@/components/EbookActivationDialog'
import CompleteInfoDialog from '@/components/CompleteInfoDialog'
import ToKingsunTeacherDialog from '@/components/ToKingsunTeacherDialog'
import TBXCodeDialog from '@/components/TBXCodeDialog'
import { Loading } from 'element-ui'
// import { resolve } from 'url'
export default {
  name: 'Panel',
  components: {
    Header,
    // BindMobilePhoneDialog,
    BindSubjectDialog,
    ToKingsunTeacherDialog,
    Footer,
    TeacherInfo,
    QRcode,
    EbookActivationDialog,
    CompleteInfoDialog,
    TBXCodeDialog
  },
  data () {
    return {
      userInfo: this.$store.state.userInfo,
      isShow: false,
      resourcePath: '',
      resourceIcon: {
        '0': require('@/assets/pic_package.png'),
        '1': require('@/assets/pic_video.png'),
        '2': require('@/assets/micro_class.png'),
        '3': require('@/assets/pic_kebenju.png'),
        '4': require('@/assets/pic_book.png'),
        '5': require('@/assets/pic_laptop.png')
      },
      resourceModule: [],
      isIntegrity: false // 个人信息是否完成
    }
  },
  watch: {
    // 'userInfo.bookInfo.bookId' (bookId) {
    //   this.$nextTick(() => {
    //     console.log('getResourcePath1')
    //     this.getResourcePath(bookId)
    //   })
    // },
    // getUserInfo (val) {
    //   console.log('getResourcePath2')
    //   this.getResourcePath(val.bookInfo.bookId)
    // }
  },
  mounted () {
    this.loadingInstance = Loading.service()
    this.dataInit()
    // // 每年8.10-10.31开放页面
    // if (this.setDate()) {
    //   this.dataInit()
    // } else {
    //   this.$refs.toKingsunTeacherDialog.showDialog()
    // }
  },
  methods: {
    async dataInit () {
      let uinfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      await this.getTeacherInfo()
      await this.getTeachingResourceType()
      // 从列表点击面包屑导航'首页'
      if (uinfo) {
        await this.getResourcePath(uinfo.bookInfo.bookId)
      }
      this.loadingInstance.close()
    },
    getTeacherInfo () {
      const u = new Promise((resolve, reject) => {
        api.getTeacherInfo(
          userInfo => {
            this.userInfo = userInfo
            this.isIntegrity = userInfo.isIntegrity
            // this.bindMobilePhoneDialog()
            // 任教科目
            if (this.userInfo.moduleType === -1) {
              // 每年8.10-10.31开放页面
              // if (this.setDate()) {
              //   this.$refs.BindSubjectDialog.showDialog()
              // } else {
              //   this.$refs.toKingsunTeacherDialog.showDialog()
              // }
              // 2020/2/1
              // this.$refs.BindSubjectDialog.showDialog()
              this.$refs.BindSubjectDialog.bindSubject()
              // 老師信息(2020/2/17)
              console.log(userInfo)
              window.sessionStorage.setItem('userInfo', userInfo)
              this.$refs.teacherInfo.resetUserInfo()
            } else if (!this.userInfo.bookInfo.bookId) {
              this.$refs.teacherInfo.changeBook()
            }
            resolve()
          },
          res => {},
          (err) => { reject(err) }
        )
      })
      return u
    },
    bindMobilePhoneDialog () {
      if (!this.userInfo.mobilePhone) {
        this.$refs.mobileBind.showDialog()
      } else if (this.userInfo.moduleType === -1) {
        this.$refs.BindSubjectDialog.showDialog()
      } else if (!this.userInfo.bookInfo.bookId) {
        this.$refs.teacherInfo.changeBook()
      }
    },
    // onCreateAccount () {
    //   this.getTeacherInfo()
    // },
    afterBindMobile () {
      this.$message({
        message: '绑定成功',
        type: 'success'
      })
      this.$refs.BindSubjectDialog.showDialog()
    },
    afterBindSubject (data) {
      // this.$refs.teacherInfo.resetUserInfo()
    },
    getResourcePath (bookId) {
      this.loadingInstance = Loading.service()
      api.post('GetDigitalBookByIdRequest', {
        bookId: bookId
      }, res => {
        if (res.body.isShow === 1) {
          this.isShow = true
          this.vipStatus = res.body.vipStatus
          if (res.body.resourcePath) {
            this.resourcePath = res.body.resourcePath
          } else {
            this.resourcePath = ''
          }
        } else {
          this.isShow = false
          this.vipStatus = 0
          this.resourcePath = ''
        }
        this.loadingInstance.close()
      })
    },
    toResourcePage (url) {
    	// 2020/2/1
    	// 模块建设中
      this.$message({
        message: '建设中',
        type: 'error'
      })
      // if (this.isIntegrity) {
      //   window.location.href = url
      // } else {
      //   this.$refs.CompleteInfoDialog.showDialog()
      // }
    },
    showCode () {
    	// 2020/2/1
    	this.$refs.myCode.show()
      // if (this.isIntegrity) {
      //   this.$refs.myCode.show()
      // } else {
      //   this.$refs.CompleteInfoDialog.showDialog()
      // }
    },
    getTeachingResourceType () {
      const m = new Promise((resolve, reject) => {
        api.post('GetTeachResourceTypeRequest', {}, res => {
          res.body.resourceTypes.forEach((r, i) => {
            r.imgUrl = this.resourceIcon[i]
            r.link = '/'
            if (i === 0) {
              r.isNew = true
            }
          })
          this.resourceModule = res.body.resourceTypes
          resolve()
        })
      })
      return m
    },
    ebookActivation (vipStatus) {
    	// 2020/2/1
    	// 模块建设中
      // this.$message({
      //   message: '建设中',
      //   type: 'error'
      // })
      // if (this.isIntegrity) {
      //   this.$refs.activationDialog.showDialog(vipStatus)
      // } else {
      //   this.$refs.CompleteInfoDialog.showDialog()
      // }
      this.$refs.TBXCodeDialog.showDialog()
    },
    afterActive () {
      console.log('getResourcePath4')
      this.getResourcePath(this.userInfo.bookInfo.bookId)
    },
    // 跳转列表页
    toResoureList (index, rtypeid, cateid, rexttypeid) {
      let rname = 'resourceList'
      if (rtypeid === 7) { // 微课学习
        rname = 'microList'
      } else if (rtypeid === 2 || rtypeid === 6) { // 教材分析、教研活动
        rname = 'analyseList'
      }
      this.$router.push({
        name: rname,
        params: {
          resourceTypeId: rtypeid,
          categoryId: cateid,
          resourceExtTypeId: rexttypeid
        }
      })
    },
    // 日期设置，每年8.10-10.31开放页面
    setDate () {
      let curDate = new Date()
        let y = curDate.getFullYear()
        let m = curDate.getMonth() + 1
        let d = curDate.getDate()
        let myDate = new Date(Date.parse(y + '/' + m + '/' + d)).getTime()
        let startDate = new Date(Date.parse(y + '/8/10')).getTime()
        let endDate = new Date(Date.parse(y + '/10/31')).getTime()
        // console.log(curDate, myDate, startDate, endDate)
        if (myDate >= startDate && myDate <= endDate) {
          return true
        } else {
          return false
        }
    }
  },
  computed: {
    getUserInfo () {
      return this.$store.state.userInfo
    }
  }
}
</script>
<style scoped>
.content {
  position: relative;
  width: 100%;
  height: 800px;
  background: url("../assets/content_bg.jpg") center bottom no-repeat;
  padding-top: 27px;
  box-sizing: border-box;
}
.content .loading {
  width: 1058px;
  position: relative;
  margin: 0 auto;
  box-sizing: border-box;
  padding-right: 220px;
  text-align: center;
}
.content .loading > img {
  padding-top: 200px;
}
.banner {
  width: 960px;
  margin: 0 auto;
}
.banner img {
  display: block;
  width: 100%;
}
.bd {
  width: 960px;
  position: relative;
  margin: 0 auto;
  box-sizing: border-box;
  padding-right: 220px;
}

.section {
  padding-top: 50px;
}
.section-hd {
  border-left: 3px solid #FE793A;
  padding-left: 8px;
  line-height: 1.2;
  margin: 0;
  font-size: 18px;
}
.section .tip {
  color: #888;
  font-size: 14px;
  margin-left: 10px;
}
.section .tip > span {
  color: #FE793A;
}

.section .outlink {
  font-size: 12px;
  color: #FE793A;
  float: right;
  margin-right: 60px;
  margin-top: 5px;
}
.section-bd {
  padding-top: 20px;
}
.section-item {
  display: inline-block;
  width: 120px;
  height: 140px;
  margin-right: 20px;
  text-align: center;
  cursor: pointer;
}
.section-item .item-img:hover {
  transform: translateY(-3px);
}
.section-item .item-img {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 92px;
  width: 120px;
  background-color: #fff;
  box-sizing: border-box;
}
.section-item .item-img img {
  width: 32px;
  height: 32px;
}
.section-item .item-title {
  margin-top: 10px;
  font-size: 14px;
  text-decoration: none;
}
.section-item .fire {
  position: absolute;
  right: 10px;
  top: 10px;
}
.section-item .item-img img.new {
  position: absolute;
  top: 0;
  right: 0;
  width: 36px;
  height: 19px;
}
.router-link-active,
a {
  color: #000;
  text-decoration: none;
}
.slogan {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 960px;
  line-height: 55px;
  font-size: 13px;
  color: #555;
  text-align: center;
}
.slogan span:first-child {
  margin-right: 30px;
}
.slogan span em {
  margin-right: 10px;
}
.right-side {
  width: 220px;
  height: 525px;
  position: absolute;
  top: 0;
  right: 0;
}
</style>
